/* Only ambiguous large collections need a client request. No persistent cache:
   stock/publication changes are evaluated again on the next page load. */
(() => {
  if (window.brincatoysCollectionAvailability) return;
  const checks = new Map();
  const queued = new WeakSet();
  const queue = [];
  let active = 0;
  const pause = ms => new Promise(resolve => setTimeout(resolve, ms));

  async function hasAvailableProduct(path) {
    const url = new URL(path, window.location.origin);
    if (url.origin !== window.location.origin || !/\/collections\/[^/]+$/.test(url.pathname)) return false;
    url.pathname += '/products.json';
    url.search = '';
    url.searchParams.set('limit', '250');
    let previousFirstId;
    for (let page = 1; ; page += 1) {
      url.searchParams.set('page', String(page));
      let response;
      for (let attempt = 0; attempt < 3; attempt += 1) {
        response = await fetch(url.href, { credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
        if (response.status !== 429 && response.status < 500) break;
        const retry = Number(response.headers.get('retry-after')) * 1000;
        await pause(Math.min(30000, retry || 1000 * (attempt + 1)));
      }
      if (response.status === 404) return false;
      if (!response.ok) throw new Error('Collection availability could not be checked');
      const { products } = await response.json();
      if (!Array.isArray(products)) throw new Error('Invalid collection response');
      if (products.some(product => product.variants?.some(variant => variant.available === true))) return true;
      if (products.length < 250) return false;
      if (products[0]?.id === previousFirstId) throw new Error('Collection pagination did not advance');
      previousFirstId = products[0]?.id;
      await pause(500);
    }
  }

  function pump() {
    while (active < 2 && queue.length) {
      const element = queue.shift();
      const path = element.dataset.btCollectionUrl;
      active += 1;
      if (!checks.has(path)) checks.set(path, hasAvailableProduct(path));
      checks.get(path).then(available => {
        element.dataset.btCollectionState = available ? 'available' : 'unavailable';
        element.hidden = !available;
        document.dispatchEvent(new CustomEvent('brincatoys:collection-availability'));
      }).catch(() => {
        // Fail closed: no unverified links, no misleading empty-collection claim.
        console.warn('Brincatoys: não foi possível verificar uma coleção; o cartão permanece oculto.');
      }).finally(() => { active -= 1; pump(); });
    }
  }

  function enhance() {
    document.querySelectorAll('[data-bt-collection-state="pending"]').forEach(element => {
      if (queued.has(element)) return;
      queued.add(element);
      queue.push(element);
    });
    pump();
  }
  window.brincatoysCollectionAvailability = { enhance };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, { once: true });
  else enhance();
  document.addEventListener('shopify:section:load', () => { checks.clear(); enhance(); });
})();
